export const TAB_IDS = ["tsuyaku", "okoshi", "zasso"] as const;
export type TabId = (typeof TAB_IDS)[number];

export const TAB_META: Record<
  TabId,
  { ja: string; romaji: string; code: string; label: string }
> = {
  // spec §2.12: status bar short codes TSU / OKO / ZAS
  tsuyaku: { ja: "訳", romaji: "TSUYAKU", code: "TSU", label: "Koe Tsuyaku" },
  okoshi: { ja: "録", romaji: "OKOSHI", code: "OKO", label: "Koe Okoshi" },
  zasso: { ja: "話", romaji: "ZASSO", code: "ZAS", label: "Koe Zasso" },
};
